var $ = require('jquery');
var KEY_UP_TIMEOUT = 1000;

var timerPostCodeKeyUp = false,
    zipFound = true, //
    zipFocused = false,
    currentFormId;

function setTabIndexesForHiddenAddress() {
    var tabindex = 7;
    $.each(['#CreditCard0CardNumber', '#CreditCard0VerificationCode', '#CreditCard0ExpirationMonth',
        '#CreditCard0ExpirationYear', '#Order',
        '#Contact0StreetAddress1', '#Contact0StreetAddress2',
        '#Contact0City', '#Contact0State', '#Contact0Country'], function (key, inputId) {

        $(inputId).attr('tabindex', tabindex++);
    });
}

function setTabIndexesForShownAddress() {
    var tabindex = 7;
    $.each(['#Contact0StreetAddress1', '#Contact0StreetAddress2',
        '#Contact0City', '#Contact0State', '#Contact0Country', '#CreditCard0CardNumber',
        '#CreditCard0VerificationCode', '#CreditCard0ExpirationMonth', '#CreditCard0ExpirationYear', '#Order'],
        function (key, inputId) {

        $(inputId).attr('tabindex', tabindex++);
    });
}

function showBillingAddress() {
    $('#billing-box').removeClass('hidden-billing');
    if ($('#Contact0StreetAddress1').val() == 'auto') {
        $('#Contact0StreetAddress1').val('');
    }
    $('#card_box .fheader span.num').html('3');

    setTabIndexesForShownAddress();
}

function GetCardType(number) {
    // visa
    var re = new RegExp("^4");
    if (number.match(re) != null)
        return "Visa";

    // Mastercard
    // Updated for Mastercard 2017 BINs expansion
    if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
        return "MasterCard";

    // AMEX
    re = new RegExp("^3[47]");
    if (number.match(re) != null)
        return "American Express";

    // Discover
    re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
    if (number.match(re) != null) {
        return "Discover";
    }

    return "";
}

function toggleSection($ul, $link, $sign) {
    if ($ul.hasClass('hidden-xs')) {
        $ul.removeClass('hidden-xs');
        $link.html('(hide details)');
        $sign.html('&minus;');
    } else {
        $ul.addClass('hidden-xs');
        $link.html('(view details)');
        $sign.html('+');
    }
}

function applySubscription(options, name) {
    jQuery.each(['SubscriptionPlanId', 'SubscriptionPlanWait', 'SubscriptionPlanProductId' ], function(key, value) {
        if (options[name][value]) {
            jQuery('#h_' + value).prop('name', value);
            jQuery('#h_' + value).prop('value', options[name][value]);
        } else {
            jQuery('#h_' + value).prop('name', '');
            jQuery('#h_' + value).prop('value', '');
        }
    });
}

function setupCheckboxOptions(options) {
    currentFormId = options.monthly.formId;

    jQuery('#deal-automator-monthly').on('click', function() {
        currentFormId = options.monthly.formId;
        jQuery('#orderForm input[name=ProductId]').prop('value', options.monthly.productId);
        jQuery('#orderForm input[name=PayTotal_A]').prop('value', options.monthly.payTotal);
        jQuery('#orderForm input[name=infusion_xid]').prop('value', options.monthly.infusionXid);
        jQuery('#orderForm input[name=infusion_name]').prop('value', options.monthly.infusionName);
        applySubscription(options, 'monthly');
        calcTotals();
    });

    jQuery('#deal-automator-lifetime').on('click', function() {
        currentFormId = options.lifetime.formId;
        jQuery('#orderForm input[name=ProductId]').prop('value', options.lifetime.productId);
        jQuery('#orderForm input[name=PayTotal_A]').prop('value', options.lifetime.payTotal);
        jQuery('#orderForm input[name=infusion_xid]').prop('value', options.lifetime.infusionXid);
        jQuery('#orderForm input[name=infusion_name]').prop('value', options.lifetime.infusionName);
        applySubscription(options, 'lifetime');
        calcTotals();
    });
}

module.exports = {
    init: function (options) {

        if (options.hideAddress) {
            $('#Contact0StreetAddress1').val('auto');

            setTabIndexesForHiddenAddress();

            $("#Contact0PostalCode").focus(function () {
                zipFocused = true;
            });

            $("#Contact0PostalCode").blur(function () {
                zipFocused = false;
                if (!zipFound) {
                    showBillingAddress();
                }
            });

            $("#Contact0PostalCode").keyup(function () {
                var zip = $(this).val(),
                    self = this;

                if (zip.length > 2) {
                    if (timerPostCodeKeyUp) {
                        clearTimeout(timerPostCodeKeyUp); //clear old interval
                    }
                    zipFound = true; //lets thing that it is ok until did not check
                    timerPostCodeKeyUp = setTimeout(function () {
                        timerPostCodeKeyUp = false;
                        var zip = $(self).val();
                        var country = $("#Contact0Country").val();
                        var data = "zip=" + zip + "&country=" + country;
                        $.ajax({
                            url     : '/tools/databyzip.php',
                            type    : 'post',
                            data    : data,
                            dataType: 'json',
                            success : function (response) {
                                zipFound = true;
                                $("#Contact0City").val(response.city);
                                $("#Contact0State").val(response.state);
                                calcTotals();
                                $("#billing-box input").removeClass('errorfield');
                                $("#billing-box label.error").prop('style', 'display:none');
                                if ($("#Contact0StreetAddress1").val()=='') {
                                    $("#Contact0StreetAddress1").val("auto");
                                }

                            },
                            error : function () {
                                zipFound = false;
                                if (!zipFocused) {
                                    showBillingAddress();
                                }
                            }
                        });
                    }, KEY_UP_TIMEOUT);
                }
            });
        }

        if (options.checkboxOptions) {
            setupCheckboxOptions(options.checkboxOptions);
        }

        // validation
        $.validator.addMethod("cardNumIsOk", function (value, element) {
            return this.optional(element) || (GetCardType(value) != 0);
        }, "Invalid card number");


        $(options.formId).validate({
            rules: {
                'Contact0StreetAddress1': {
                    required: true
                },
                'Contact0City': {
                    required: true
                },
                'Contact0State': {
                    required: true
                },

                'Contact0FirstName': {
                    required: true
                },
                'Contact0LastName': {
                    required: true
                },
                'Contact0Email': {
                    required: true,
                    email: true
                },
                'Contact0PostalCode': {
                    required: true
                },
                'Contact0Phone1': {
                    required: true,
                    usPhone: true,
                    minlength : 10,
                    maxlength : 15
                },
                'Contact0Password': {
                    required: true,
                    minlength : 6
                },
                'conformbox': {
                    required: true
                },
                'CreditCard0CardNumber': {
                    required: true,
                    cardNumIsOk: true
                },
                'CreditCard0VerificationCode': {
                    required: true
                },
                'CreditCard0ExpirationMonth': {
                    required: true
                },
                'CreditCard0ExpirationYear': {
                    required: true
                }
            },
            submitHandler: function (form) {
                $("#Order").attr('disabled', 'disabled');
                $.ajax({
                    type: 'post',
                    url: '/tools/secure.php',
                    dataType: 'json',
                    data: {
                        email: $("#Contact0Email").val(),
                        firstName: $("#Contact0FirstName").val(),
                        pass: $("#Contact0Password").val(),
                        sid: options.sessionId
                    }
                }).done(function (data) {
                    form.submit();
                });
            }
        });


        //hint
        $("#helpimg").mouseover(function () {
            $('#cvchint').css('display','none');
            $('#cvchint').removeClass('cvchinthidden');
            $('#cvchint').fadeIn();
        });
        $("#helpimg").mouseout(function () {
            $('#cvchint').fadeOut(function () {
                $('#cvchint').addClass('cvchinthidden');
            });
        });

        $("#CreditCard0CardNumber").keyup(function () {
            var num = $(this).val();
            var card_type = GetCardType(num);

            if (card_type !== "") {

                $("#CreditCard0CardType").val(card_type);
                // hilight selected type
                $(".cardimg").addClass("img_gr");

                if (card_type == "Visa") {
                    $("#visa").removeClass("img_gr");
                } else if (card_type == "MasterCard") {
                    $("#mastercard").removeClass("img_gr");
                } else if (card_type == "American Express") {
                    $("#amex").removeClass("img_gr");
                } else if (card_type == "Discover") {
                    $("#discover").removeClass("img_gr");
                }
            } else {
                $(".cardimg").removeClass("img_gr");
            }
        });

        $('#Order').mouseenter(function () {
            $('#Order img').prop('src', '/images/checkout/CCA-button.gif');
        }).mouseleave(function () {
            $('#Order img').prop('src', '/images/checkout/CCA-button-default.png');
        })
    },
    getFormId: function () {
        return currentFormId;
    },
    setFormId: function (formId) {
        currentFormId = formId;
    }
};